var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "waf-component waf-fantasy-contests" }, [
    _c("div", { staticClass: "layout-wrapper" }, [
      _c("div", { staticClass: "waf-head" }, [
        _c("h3", { staticClass: "widget-title" }, [
          _vm._v(_vm._s(_vm.titleTxt())),
        ]),
      ]),
      _vm._v(" "),
      _vm.contest_loaded
        ? _c("div", { staticClass: "waf-body" }, [
            _vm.contests_list && _vm.contests_list.length
              ? _c(
                  "div",
                  { staticClass: "contest-list" },
                  _vm._l(_vm.contests_list, function (contest_details, idx) {
                    return _c(
                      "a",
                      {
                        key: idx,
                        class: [
                          "contest-item img-1by1",
                          { disabled: _vm.current_match.status !== 1 },
                        ],
                        attrs: {
                          href: _vm.getRedirectURL(contest_details),
                          target: "_blank",
                          rel: "nofollow",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onContestClick(contest_details, $event)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "contest-thumbnail" }, [
                          _c("div", { staticClass: "img-box" }, [
                            _c("img", {
                              staticClass: "loading",
                              attrs: {
                                src: _vm.getImageUrl(contest_details),
                                alt: contest_details.cid,
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "contest-info" }, [
                          _c("div", { staticClass: "info-wrap" }, [
                            _c("div", { staticClass: "info-section1" }, [
                              _c("div", { staticClass: "info-section-wrap" }, [
                                _c("div", { staticClass: "name" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.translations.currency_symbol) +
                                      "\n                    " +
                                      _vm._s(
                                        _vm.convert_number(contest_details.tp)
                                      ) +
                                      "\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "price-detail" }, [
                                  _c("span", { staticClass: "entry-fee" }, [
                                    _vm._v(
                                      _vm._s(_vm.translations.entry) +
                                        "\n                      " +
                                        _vm._s(
                                          _vm.translations.currency_symbol
                                        ) +
                                        "\n                      " +
                                        _vm._s(
                                          _vm.convert_number(contest_details.ef)
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "spot" }, [
                                    _vm._v(
                                      _vm._s(_vm.translations.spots) +
                                        ":\n                      " +
                                        _vm._s(
                                          Number(
                                            contest_details.pc
                                          ).toLocaleString("en-IN")
                                        )
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "contest-rating" }, [
                                _c("span", { staticClass: "profit" }, [
                                  _vm._v(
                                    _vm._s(_vm.translations.approx_winnings)
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    class: [
                                      "rating",
                                      contest_details.ar < 0
                                        ? "loss"
                                        : contest_details.ar !== 0
                                        ? "success"
                                        : "",
                                    ],
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.translations.currency_symbol) +
                                        "\n                    " +
                                        _vm._s(
                                          _vm.convert_number(contest_details.mp)
                                        )
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-section2" }, [
                              _c("span", { staticClass: "prize-pool" }, [
                                _vm._v(
                                  _vm._s(_vm.translations.top_prize) +
                                    ":\n                  " +
                                    _vm._s(_vm.translations.currency_symbol) +
                                    "\n                  " +
                                    _vm._s(
                                      _vm.convert_number(contest_details.hp)
                                    )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "winning" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.getParticipantBracket(
                                        contest_details,
                                        _vm.translations.contestType
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                )
              : _c("div", { staticClass: "contest-list" }, [
                  _c("div", { staticClass: "no-data" }, [
                    _c("p", { staticClass: "msg" }, [
                      _vm._v(_vm._s(_vm.translations.noContestsFound)),
                    ]),
                  ]),
                ]),
            _vm._v(" "),
            _vm.contests_list && _vm.contests_list.length
              ? _c("div", { staticClass: "btn-wrap" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-link",
                      attrs: { href: _vm.getViewAllLink() },
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.translations.viewAll))]),
                      _vm._v("(" + _vm._s(_vm.contest_count) + ")"),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.contests_list && _vm.contests_list.length
              ? _c("p", { staticClass: "disclaimer-txt" }, [
                  _vm._v(_vm._s(_vm.translations.contestDisclaimer)),
                ])
              : _vm._e(),
          ])
        : _c("div", { staticClass: "waf-body" }, [
            _c(
              "div",
              { staticClass: "contest-list" },
              _vm._l([1, 2, 3], function (c) {
                return _c(
                  "a",
                  {
                    key: c,
                    staticClass: "contest-item img-1by1",
                    attrs: { rel: "nofollow" },
                  },
                  [_vm._m(0, true), _vm._v(" "), _vm._m(1, true)]
                )
              }),
              0
            ),
          ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contest-thumbnail shimmer" }, [
      _c("div", { staticClass: "img-box" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contest-info shimmer" }, [
      _c("div", { staticClass: "info-wrap" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }